<template>
  <div id="mypage" class="rew18-contents">
    <div class="rew18-contents-banner rew19_missTop" style="background-image: url('https://resource2018.nuskinkorea.co.kr/images/renew/mypage/mypage_bg.png')">

      <div class="rew18-contents-banner__text">
        <h1>로그인</h1>
        <p><strong>뉴스킨 코리아</strong>에 <br class="m-br"> 오신 것을 환영합니다.</p>
      </div>

    </div>

    <div class="rew18-contents-inner">

      <div class="login-box">
        <div class="login-box__form">
          <form method="post" id="member" name="member">
            <input type="hidden" name="refer1" value=""/>
            <input type="hidden" name="refer2" value=""/>
            <input type="hidden" name="userRefer" value=""/>

            <div class="login-box__input">
              <label for="member_id">회원번호</label>
              <input v-model="member_id" type="text" id="member_id" name="member_id" value="KR" class="numeng upper rew18_inputTxt_t1" title="회원번호 입력" tabindex="1"/>
            </div>

            <div class="login-box__input">
              <label for="passwd">비밀번호</label>
              <input v-model="passwd" type="password" id="passwd"  name="passwd" class="rew18_inputTxt_t1" title="비밀번호 입력" tabindex="2" />
            </div>

            <div class="login-box__button">
              <!--<button type="button" onclick="javascript:joinSubmit();">로그인</button>-->
              <button type="button" @click="onClickLogin();">로그인</button>
            </div>

            <div class="rew18_wrapCheck_t1 rew18_payment_agreeIp">
              <input type="checkbox" class="rew18_fakeCheck_t1" name="rememberMe" id="login-check_1" value="true" tabindex="3">
              <label for="login-check_1">
                로그인 상태 유지
              </label>
            </div>
          </form>
        </div>

        <div class="login-box__find">
          <a href="#" class="login-box__find__btn">회원 가입</a> │
          <a href="#" class="login-box__find__btn">회원번호 찾기</a> │
          <a href="#" class="login-box__find__btn">비밀번호 재설정</a>
        </div>

      </div>

      <div class="login-join">

        <div class="rew18-flex-box">
          <div class="login-join-text" style="padding-right:15px;">오프라인 또는 후원자의 마이 사이트에서 가입한 회원은 ‘웹 계정 설정’ 에서 KR번호의 비밀번호를 설정한 이후에 뉴스킨몰을 이용하실 수 있습니다.</div>
          <div class="login-join-btn">
            <a href="#" class="rew18_btn_T2"><span>웹 계정 설정</span></a>
          </div>
        </div>

      </div>

    </div>

  </div>

</template>
<script>
import AroBase from '@/components/base/AroBase';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import PageNav from "@/components/paging/pageNav";

export default {
  name: "aroLogin",
  extends: AroBase,
  components: {
    PageNav,
  },
  computed: {
    accordionClasses: function () {
      return {
        'state_close': !this.isOpen,
        'state_open': this.isOpen
      };
    }
  },

  data() {
    //View Data
    return {
      isOpen: false,
      viewData: {
        master_list: []
      },

      //주문상품 변경
      productChangeDialog: {},

      // aro 장바구니 이름 변경
      aroNameChangeDialog: {},

      member_id:"",
      passwd:"",

      Base64ReplaceUrl : {

        Base64 : {

          // private property
          _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

          // private method for UTF-8 encoding
          _utf8_encode: function (string) {
            string = string.replace(/\r\n/g, "\n");
            let utftext = "";

            for (var n = 0; n < string.length; n++) {

              let c = string.charCodeAt(n);

              if (c < 128) {
                utftext += String.fromCharCode(c);
              }
              else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
              }
              else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
              }

            }

            return utftext;
          },

          // private method for UTF-8 decoding
          _utf8_decode: function (utftext) {
            let string = "";
            let i = 0;
            let c1 = 0;
            let c2 = 0;
            let c3 = 0;
            let c = 0;

            while (i < utftext.length) {

              c = utftext.charCodeAt(i);

              if (c < 128) {
                string += String.fromCharCode(c);
                i++;
              }
              else if ((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i + 1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
              }
              else {
                c2 = utftext.charCodeAt(i + 1);
                c3 = utftext.charCodeAt(i + 2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
              }

            }

            return string;
          },

          // public method for encoding
          encode: function (input) {
            if (input == "" || input == undefined) {
              return "";
            }

            let output = "";
            let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            let i = 0;

            input = this._utf8_encode(input);

            while (i < input.length) {

              chr1 = input.charCodeAt(i++);
              chr2 = input.charCodeAt(i++);
              chr3 = input.charCodeAt(i++);

              enc1 = chr1 >> 2;
              enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
              enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
              enc4 = chr3 & 63;

              if (isNaN(chr2)) {
                enc3 = enc4 = 64;
              } else if (isNaN(chr3)) {
                enc4 = 64;
              }

              output = output +
                this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

            }

            return output;
          },

          // public method for decoding
          decode: function (input) {
            if (input == "" || input == undefined) {
              return "";
            }

            let output = "";
            let chr1, chr2, chr3;
            let enc1, enc2, enc3, enc4;
            let i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

              enc1 = this._keyStr.indexOf(input.charAt(i++));
              enc2 = this._keyStr.indexOf(input.charAt(i++));
              enc3 = this._keyStr.indexOf(input.charAt(i++));
              enc4 = this._keyStr.indexOf(input.charAt(i++));

              chr1 = (enc1 << 2) | (enc2 >> 4);
              chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
              chr3 = ((enc3 & 3) << 6) | enc4;

              output = output + String.fromCharCode(chr1);

              if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
              }
              if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
              }

            }

            output = this._utf8_decode(output);

            return output;

          },

          URLEncode: function (string) {
            return escape(this._utf8_encode(string));
          },

          // public method for url decoding
          URLDecode: function (string) {
            return this._utf8_decode(unescape(string));
          }
        },

        /**
         * public method for encoding replace
         * @param vInput {string} Base64 encode data
         * @return {string} Base64ReplaceUrl data
         */
        encode: function (vInput) {
          if (undefined === vInput || null === vInput || "" === vInput) {
            return "";
          }

          let output = vInput.replace(/=/g, "_");
          output = output.replace(/\+/g, "-");
          output = output.replace(/\//g, "!");

          return output;
        },

        /**
         * public method for decoding replace
         * @param vInput {string} Base64ReplaceUrl data
         * @return {string} Base64 encode data
         */
        decode: function (vInput) {
          if (undefined === vInput || null === vInput || "" === vInput) {
            return "";
          }

          let output = vInput.replace(/_/g, "=");
          output = output.replace(/-/g, "+");
          output = output.replace(/!/g, "/");

          return output;

        },

        /**
         *
         * @param vJson {{}}
         * @return {string}
         */
        encodeJson: function (vJson) {
          let _this = this;

          if (undefined === vJson || null === vJson) {
            return "";
          }

          let output = "";

          try {
            let jsonStr = JSON.stringify(vJson);
            if (undefined === jsonStr || null === jsonStr || "" === jsonStr) {
              return "";
            }

            let encodeInput = _this.Base64.encode(jsonStr);
            if (undefined === jsonStr || null === jsonStr || "" === jsonStr) {
              encodeInput = "";
            }

            output = this.encode(encodeInput);

          } catch (e) {

          }

          return output;
        },

        /**
         *
         * @param vBase64ReplaceUrl {string}
         * @return {*}
         */
        decodeJson: function (vBase64ReplaceUrl) {
          let _this = this;

          if (undefined === vBase64ReplaceUrl || null === vBase64ReplaceUrl || "" === vBase64ReplaceUrl) {
            return "";
          }

          let output = {};

          try {
            let encodeJsonBase64 = this.decode(vBase64ReplaceUrl);
            if (undefined !== encodeJsonBase64 && null !== encodeJsonBase64 && "" !== encodeJsonBase64 && 0 < encodeJsonBase64.length) {
              let paramsJsonStr = _this.Base64.decode(encodeJsonBase64);
              if (undefined !== paramsJsonStr && null !== paramsJsonStr && "" !== paramsJsonStr && 0 < paramsJsonStr.length) {
                output = JSON.parse(paramsJsonStr);
              }
            }
          } catch (e) {

          }

          return output;
        }
      }
    }
  },

  created() {
    console.debug(`aroLogin created`);
  },
  mounted() {
    console.debug(`aroLogin mounted`);

    let _this = this;

    //_this.loadList(1);
  },

  beforeDestroy() {
    console.debug(`aroLogin beforeDestroy`);

    let _this = this;
  },

  destroyed() {
    console.debug(`aroLogin destroyed`);

    let _this = this;
  },

  methods: {

    /**
     * API Request
     */
    toggle: function (item) {
      //this.isOpen = !this.isOpen;
      if (this.isOpen === item.aro_no) {
        this.isOpen = false;
      } else {
        this.isOpen = item.aro_no;
      }
    },

    apiGetAro(pageNo) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan: '',
          page: pageNo,
          countPerPage: 10
        }
      });
    },

    // 주문상품 변경
    apiChangeProduct(aro_no, pd_add_list) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_product`, {
        params: {
          aro_no: aro_no,
          pd_add_list: JSON.stringify(pd_add_list)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus: function (aro_no) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo: aro_no
        }
      });
    },

    // aro 장바구니 이름 변경
    apiAroPutTags: function (aro_no, aro_tag) {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_tags`, {
        params: {
          adpNo: aro_no,
          aroTag: aro_tag
        }
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadList(pageNo) {
      let _this = this;

      //init data
      _this.viewData = {
        ..._this.viewData,
        countPerPage: _this.countPerPage,
        page: 1,
        totalHistory: 0,
        history_list: []
      };
    },

    onClickPage(pageNo) {
      let _this = this;

      _this.loadList(pageNo);
    },

    //상세 이동
    onClickDetail(item) {
      let _this = this;
    },

    //Open dialog 주문상품 변경
    openProductChangeDialog(aro_no, list, prod_add_yn, payment_count) {
      let _this = this;

      //pass data to dialog
      _this.productChangeDialog = {
        ..._this.productChangeDialog,
        pd_list: list,
        aro_no: aro_no,
        aro_payment_count: payment_count,
      };
    },

    //주문상품 변경
    productChange(isOk, data) {
      let _this = this;

    },

    //Open dialog aro 장바구니 이름 변경
    openAroNameChangeDialog(aro_no, aro_tag) {
      let _this = this;

      //pass data to dialog
      _this.aroNameChangeDialog = {
        ..._this.aroNameChangeDialog,
        aro_no: aro_no,
        aro_tag: aro_tag
      };
    },

    // aro 장바구니 이름 변경
    aroNameChange(isOk, data) {
      let _this = this;

    },

    apiAutoPaymentDate() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    },

    //상품 클릭
    /*
    onClickLogin() {
      console.debug(`aroLogin onClickLogin`);

      let _this = this;

      const memberIdVal = _this.member_id;
      const memberPwVal = _this.passwd;

      console.debug(`aroLogin memberIdVal = ` + memberIdVal + ' memberPwVal = ' + memberPwVal);

      let formData = new FormData(document.getElementById('member'));
      //let formData = new FormData();
      formData.append('member_id', memberIdVal);
      formData.append('passwd', memberPwVal);

      console.debug(`aroLogin formData memberIdVal = ` + formData.get('member_id') + ' memberPwVal = ' + formData.get('passwd'));

      _this.$showLoading();
      _this.$http.post(`${_this.$aroApiBasePath}/app/mo/Login`, formData, {
        params: {
          refer2:'12323',
        },

        // member: {
        //   member_id: memberIdVal,
        //   passwd: memberPwVal,
        // },

        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },

        //
        // body: {
        //   member: {
        //     member_id: memberIdVal,
        //     passwd: memberPwVal,
        //   },
        // }

      }).then(res => {
        if (res.status === 200) {
          //_this.$router.push(`${_this.$aroBasePath}/basket`);
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
    */

    onClickLogin() {
      console.debug(`aroLogin onClickLogin`);

      let _this = this;

      const memberIdVal = _this.member_id;
      const memberPwVal = _this.passwd;

      console.debug(`aroLogin memberIdVal = ` + memberIdVal + ' memberPwVal = ' + memberPwVal);

      //_this.$http.defaults.withCredentials = true;

      _this.$showLoading();
      _this.$http.get(`${_this.$aroApiBasePath}/mobile/login`, {
      //_this.$http.get(`http://10.132.101.183/app`, {
        params: {
          memberId: memberIdVal,
          passwd: memberPwVal,
        },

        //credentials: "include",

      }).then(res => {
        if (res.status === 200) {
          //_this.$router.push(`${_this.$aroBasePath}/basket`);

          const dataVal = res.data;
          const trimDataVal = dataVal.substring(1, dataVal.length - 1);
          const data = JSON.parse(trimDataVal);

          if (data.result === '1') {
            const memberAuthKey = data.memberAuthKey;
            const encodeJson = {
              memberId: memberIdVal,
              memberAuthKey: memberAuthKey,
              url: '/app',
            }

            let encodeData = _this.Base64ReplaceUrl.encodeJson(encodeJson);
            _this.$http.get(`${_this.$aroApiBasePath}/mo/MobileLogin`, {
              params: {
                encodeData: encodeData,
              },

              //credentials: "include",

            }).then(res => {
              _this.$hideLoading();
              if (res.status === 200) {
                _this.$router.push(`${_this.$aroBasePath}/basket`);
              }

            }).catch((err) => {
              console.error(err);
              _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
                .then(res => {
                });

            }).finally(() => {
              //hide loading
              _this.$hideLoading();
            });
          } else {
            _this.$dialogs.alert(data.message, {title: data.message})
          }
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },
  }
}
</script>
<style>
.rew19_btn_blackarrow, .rew19_btn_upDown{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/aroLogin.vue